<template>
  <datarows-viewer
    ref="datarowsViewer"
    :fields="fields"
    :api-url="url"
    :api-headers="headers"
    :api-extra-payloads="parameters"
  >
    <span slot="header"></span>
  </datarows-viewer>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';

import { DatarowsViewer } from '@components/DatarowsViewer';

import { default as columns } from './utils/exportColumns';
import { default as claimingGroupOptions } from './utils/claimingGroupOptions';

export default defineComponent({
  name: 'SaveReportWizardPreview',
  components: {
    DatarowsViewer,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const url = computed(() => `/lincoln/export/data/`);

    const headers = computed(() => ({}));

    const parameters = computed(() => {
      const params = props.params;

      if (params.group_by.includes('*'))
        params.group_by = claimingGroupOptions
          .filter((item) => '*' !== item.value)
          .map((item) => item.value);

      return params;
    });

    const fields = computed(() =>
      columns
        .filter((item) => {
          if (props.params.columns_to_show)
            return props.params.columns_to_show.includes(item.value);
          else return true;
        })
        .map((item) => ({
          key: item.value,
          label: item.text,
          sortable: item.sortable,
          width: item.width,
          decimals: item.decimals || null,
          isDate: item.isDate || false,
        }))
    );

    return {
      url,
      headers,
      parameters,
      fields,
    };
  },
});
</script>
